import template from './customer.edit.html';
import controller from './customer.edit.controller';
import './customer.edit.scss';

let customereditComponent = {
  restrict: 'E',
  bindings: {
    hasACL:'='
  },
  template,
  controller
};

export default customereditComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/customer/edit/customer.edit.component.js